import {
  Operator,
} from "@/components/operator/scripts/types";

import {
  addressHasChanges,
  bankAccountHasChanges,
  createEmptyBankAccount,
  createNewAddress,
  createNewPerson,
  personHasChanges,
  resetAddressObject,
  resetBankAccountObject,
  resetPersonObject,
} from "@/scripts/Common/helpers";

import {
  VatDetail,
} from "@/scripts/Common";

import {
  vatDetailHasChanges,
} from "@/scripts/Common/helpers/vatDetailHelpers";

import {
  copyObject,
} from "@/scripts/Common/HelperFunctions";

const createEmptyOperator = () => {
  const operator: Operator = {
    id: 0,
    companyName: '',
    contactEmployeeId: 0,
    contactEmployee: createNewPerson(),
    contactAddressId: 0,
    contactAddress: createNewAddress(),
    creditorId: '',
    businessBankAccountId: 0,
    businessBankAccount: createEmptyBankAccount(),
    escrowBankAccountId: 0,
    escrowBankAccount: createEmptyBankAccount(),
    defaultProvision: 0,
    sepaSddMandatorReference: '',
    sepaSddSignatureDate: '',
    vatDetails: [],
    productname: '',
    maxCardLimit: 0,
    topUpLimitPerMonth: 0,
    maxMonthlyTopUpAmount: 0
  }

  return operator;
}

const resetOperatorObject = (originalObject: Operator, changedObject: Operator) => {
  changedObject.id = originalObject.id;
  changedObject.companyName = originalObject.companyName;
  changedObject.contactEmployeeId = originalObject.contactEmployeeId;
  resetPersonObject(originalObject.contactEmployee, changedObject.contactEmployee);
  changedObject.contactAddressId = originalObject.contactAddressId;
  resetAddressObject(originalObject.contactAddress, changedObject.contactAddress);
  changedObject.creditorId = originalObject.creditorId;
  changedObject.businessBankAccountId = originalObject.businessBankAccountId;
  resetBankAccountObject(originalObject.businessBankAccount, changedObject.businessBankAccount);
  changedObject.escrowBankAccountId = originalObject.escrowBankAccountId;
  resetBankAccountObject(originalObject.escrowBankAccount, changedObject.escrowBankAccount);
  changedObject.defaultProvision = originalObject.defaultProvision;
  changedObject.sepaSddMandatorReference = originalObject.sepaSddMandatorReference;
  changedObject.sepaSddSignatureDate = originalObject.sepaSddSignatureDate;
  changedObject.vatDetails = copyObject(originalObject.vatDetails);
  changedObject.productname = originalObject.productname;
  changedObject.maxCardLimit = originalObject.maxCardLimit;
  changedObject.topUpLimitPerMonth = originalObject.topUpLimitPerMonth;
  changedObject.maxMonthlyTopUpAmount = originalObject.maxMonthlyTopUpAmount;
}

const operatorHasChanges = (originalObject: Operator, changedObject: Operator) => {
  return changedObject.id !== originalObject.id
    || changedObject.companyName !== originalObject.companyName
    || changedObject.contactEmployeeId !== originalObject.contactEmployeeId
    || personHasChanges(originalObject.contactEmployee, changedObject.contactEmployee)
    || changedObject.contactAddressId !== originalObject.contactAddressId
    || addressHasChanges(originalObject.contactAddress, changedObject.contactAddress)
    || changedObject.creditorId !== originalObject.creditorId
    || changedObject.businessBankAccountId !== originalObject.businessBankAccountId
    || bankAccountHasChanges(originalObject.businessBankAccount, changedObject.businessBankAccount)
    || changedObject.escrowBankAccountId !== originalObject.escrowBankAccountId
    || bankAccountHasChanges(originalObject.escrowBankAccount, changedObject.escrowBankAccount)
    || changedObject.defaultProvision !== originalObject.defaultProvision
    || changedObject.sepaSddMandatorReference !== originalObject.sepaSddMandatorReference
    || changedObject.sepaSddSignatureDate !== originalObject.sepaSddSignatureDate
    || !vatDetailsEqual(originalObject.vatDetails, changedObject.vatDetails)
    || changedObject.productname !== originalObject.productname
    || changedObject.maxCardLimit !== originalObject.maxCardLimit
    || changedObject.topUpLimitPerMonth !== originalObject.topUpLimitPerMonth
    || changedObject.maxMonthlyTopUpAmount !== originalObject.maxMonthlyTopUpAmount;
}

const vatDetailsEqual = (originalObject: VatDetail[], changedObject: VatDetail[]) => {
  return Array.isArray(originalObject)
    && Array.isArray(changedObject)
    && originalObject.length === changedObject.length
    && originalObject.every((val, index) => !vatDetailHasChanges(val, changedObject[index]));
}

export {
  createEmptyOperator,
  resetOperatorObject,
  operatorHasChanges
}
